export default __webpack_public_path__ + "static/media/cointracker.f767d4f3.jpg";